import { render, staticRenderFns } from "./SearchNav.vue?vue&type=template&id=1a2b967a&scoped=true&"
import script from "./SearchNav.vue?vue&type=script&lang=js&"
export * from "./SearchNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b967a",
  null
  
)

export default component.exports